<div class="wizard-item">
    <div class="row">
        <div class="col-12 wizard-question l-title-subtitle-align">
            {{'contractModifications.wizard.questions.WhichIsThePeriodYouWantToPostpone' | translate}}
        </div>
    </div>
    <div class="row justify-content-center">
        <div class="col-md-8 col-lg-6 col-xl-6 col-xxl-5 col-xxxl-4 l-calendar-box">
            <label class="">
                <span class="l-calendar-date-label">
                    {{'contractModifications.wizard.from' | translate}}
                </span>
                {{postponedPeriodRange?.start | localizedDate:"MMMM YYYY"}}
                <span class="l-calendar-date-label">
                    {{'contractModifications.wizard.to' | translate}}
                </span>
                {{postponedPeriodRange?.end | localizedDate:"MMMM YYYY"}}
            </label>
            <div class="l-custom-calendar-container">
                <kendo-multiviewcalendar
                    kendoDateRangeSelection
                    [selectionRange]="postponedPeriodRange"
                    (selectionRangeChange)="onSelectionRangeChange($event)"
                    [views]=1
                    bottomView="year"
                    topView="decade"
                    [disabledDates]="diasblePastMonths"
                >
                </kendo-multiviewcalendar>
            </div>
        </div>
    </div>

    <div class="d-flex justify-content-center">

            <button 
                class="btn primary-btn"
                [disabled]="!postponedPeriodRange?.start || !postponedPeriodRange?.end"
                (click)="handleNextStep(wizardStepsEnum.ContractModification_PostponePeriod)"
            >
                {{'contractModifications.wizard.continueBtn' | translate}}
            </button>
    
    </div>
</div>